import { createSelector } from 'reselect';
import { getReportData } from 'src/modules/report/selectors/getReportData';

export const getReportAttachments = createSelector([
  getReportData,
], (data) => data.attachments);
